export const AGGREGATE_TYPE_COUNT = 'count';
